<template>
    <v-col cols="12" class="dashboard mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                        style="position: relative"
                >
                    <v-menu  offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    v-on="on"
                                    absolute
                                    dark
                                    fab
                                    right
                                    color="#0172C0"
                                    class="shadow-1"
                            >
                                <v-icon>mdi-flash</v-icon>
                            </v-btn>
                        </template>
                        <v-card
                            color="#FFF"
                            width="300px"
                            class="pa-5 rounded-lg shadow-1"
                        >
                            <h4>Servicios Neocity</h4>
                            <v-row >
                                <v-col cols="3" v-for="iconCArdMenu in 20">
                                    <v-btn
                                            dark
                                            fab
                                            small
                                            color="grey"
                                    >
                                        <v-icon>mdi-flash-circle</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-menu>
                    <h2 class="mt-4 font-weight-medium text-center font-family-1 font-size-30">Escritorio <span class="blue--text">de Administración</span></h2>
                    <v-row>
                        <v-col md="12" lg="8" xl="6" class="pr-0">
                            <v-card
                                    class="pa-4 pr-0 elevation-0"
                                    tile
                                    height="100%"
                            >
                                <h4 class="font-weight-medium font-family-1 font-size-18 pb-4">Perfil <span class="blue--text">Generador</span></h4>

                              
                                    <v-row>
                                        <v-col cols="5" class="pr-0">
                                         <v-card
                                                    class="card-profile-bienvenida rounded-lg rounded-br-0 rounded-tr-0 shadow-1"
                                                    color="#0172C0"
                                                    height="88px"
                                            >
                                            <v-row>
                                                <v-col class="pl-8 text-center " cols="4">
                                                    <v-avatar size="50px" class="mt-2">
                                                        <img
                                                                src="@/assets/images/perfil.png"
                                                                alt="John"
                                                        >
                                                    </v-avatar>
                                                </v-col>
                                                <v-col  cols="8" class="my-auto pl-0">
                                                    <h4 class="white--text"> <span class="font-weight-light">Hola,</span> Nombre Apellido</h4>
                                                </v-col>
                                            </v-row>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="7" class="pl-0">
                                            <v-card
                                                    class="card-profile-bienvenida-datos px-5 py-3 rounded-lg rounded-bl-0 rounded-tl-0 shadow-1"
                                                    color="#FFF"
                                                    height="88px"

                                            >
                                                <v-row>
                                                    <v-col cols="2" class="pa-1">
                                                        Empresa:
                                                    </v-col>
                                                    <v-col cols="10" class="pa-1">

                                                        <v-select
                                                                style="height:25px"
                                                                :items="['NEOCITY ENERGÍA']"
                                                                value="NEOCITY ENERGÍA"
                                                                dense
                                                        ></v-select>

                                                    </v-col>
                                                </v-row>

                                                <v-row>
                                                    <v-col cols="2" class="pa-1">
                                                        Rut:
                                                    </v-col>
                                                    <v-col cols="10" class="pa-1">
                                                        <h4 class="blue--text">11.111.111-1</h4>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>

                                    </v-row>
                                
                                <v-row>
                                    <v-col cols="3">
                                        <h4 class="font-weight-bold font-size-16">Mi empresa en números</h4>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-select
                                                class="select-color-blue-min"
                                                :items="['ABR / 19 - Mar / 20']"
                                                value="ABR / 19 - Mar / 20"
                                                dense
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-col cols="12" class="px-0 pt-0">
                            
                                <v-carousel height="200px" hide-delimiters>
                                            <v-carousel-item
                                            v-for="(item,i) in 2"
                                            :key="i"
                                            >
                                                <v-row>
                                                    <v-col>
                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                            <h3 class="grey--text">Grafico {{1+(i)}}</h3>
                                                        </v-card>
                                                    </v-col>

                                                    <v-col>
                                                    
                                                        <v-card color="#f9f9f9" class="elevation-1 rounded-lg pa-3" height="180px">
                                                            <h3 class="grey--text">Grafico {{2+(i+1)}}</h3>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                            </v-carousel-item>
                                        </v-carousel>
                       

                                </v-col>
                                
                                <v-card class="rounded-lg elevation-0 pa-3" color="#F6F6F6" >
                                    <v-row>
                                        <v-col cols="12" md="4" class="calculadora">
                                           
                                                    <h4 class="font-size-16">Datos de la empresa</h4>
                                            <v-row>
                                                    <v-col>
                                                        <v-card height="auto" class="card-numeros2 shadow-1 rounded-lg pa-3">
                                                                <v-row >
                                                                    <v-col cols="12" md="10" class="mx-auto">
                                                                        <h2 class="color-green">100<span class="color-blue">/500 GW</span></h2>
                                                                        <p class="mb-0 color-grey">ofrecidos / Vendidos </p>
                                                                        <p class="mb-0 color-grey">Ultimos 12 meses</p>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row class="">
                                                                    <v-col cols="12" md="10" class="mx-auto">
                                                                        <h2 class="color-green">38<span  class="color-blue">USD/MWh</span></h2>
                                                                        <p class="color-grey">Precio Promedio de Venta</p>
                                                                    </v-col>
                                                                </v-row>
                                                        </v-card>
                                                </v-col>
                                            </v-row>
                                            
                                            <v-row>
                                                <v-col>
                                                <v-card height="auto" class="card-numeros2 shadow-1 rounded-lg pa-3">
                                                        <v-row class=" d-flex align-center">
                                                            <v-col cols="12" md="10" class="mx-auto">
                                                                <h2 class="color-blue">18</h2>
                                                                <h3 class="color-blue">Solicitudes de<br> compra</h3>
                                                                <p class="color-grey">Para tus ofertas de energía</p>
                                                            </v-col>
                                                        </v-row>
                                                </v-card>
                                                </v-col>
                                            </v-row>
                                        
                                            

                                        </v-col>
                                        <v-col cols="12" md="8">
                                            <h4 class="font-size-16">Oferta Neocity</h4>
                                            <v-row>
                                                <v-col>
                                                     <v-card height="auto" class="card-numeros2 shadow-1 rounded-lg pa-3">
                                                        <v-row class="blue--text">
                                                            <v-col cols="12" md="3">
                                                                <h2 class="color-blue text-center">150</h2>
                                                            </v-col>
                                                            <v-col cols="12" md="9" class>
                                                                <h3 class="color-blue">Puntos de retiro</h3>
                                                                <p class="color-grey">Potenciales solicitudes de cotización</p>
                                                            </v-col>
                                                        </v-row>
                                                         <v-row class="">
                                                                <v-col cols="12" md="3" class="mx-auto text-center">
                                                                    <p class="color-green mb-0">Plan Full</p>
                                                                    <h2 class="color-blue">6</h2>
                                                                    <p class="color-grey mt-3">ofertas</p>
                                                                </v-col>
                                                                <v-col cols="12" md="3" class="mx-auto text-center">
                                                                    <p class="color-green mb-0">25 MW</p>
                                                                    <h2 class="color-blue">44</h2>
                                                                    <p class="color-grey mt-3">ofertas</p>
                                                                </v-col>
                                                                <v-col cols="12" md="3" class="mx-auto text-center">
                                                                    <p class="color-green mb-0">5 MW</p>
                                                                    <h2 class="color-blue">30</h2>
                                                                    <p class="color-grey mt-3">ofertas</p>
                                                                </v-col>
                                                                 <v-col cols="12" md="3" class="mx-auto text-center">
                                                                     <p class="color-green mb-0">1 MW</p>
                                                                    <h2 class="color-blue">70</h2>
                                                                    <p class="color-grey mt-3">ofertas</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <h4 class="font-size-16">Ofertas por zona</h4>
                                            <v-row>
                                                <v-col>
                                                     <v-card height="auto" class="card-numeros2 shadow-1 rounded-lg pa-3">
                                                            <v-row class="">
                                                                <v-col cols="12" md="4" class="mx-auto text-center">
                                                                    <h2 class="color-blue">20</h2>
                                                                    <p class="color-grey">Zona Norte</p>
                                                                </v-col>
                                                                <v-col cols="12" md="4" class="mx-auto text-center">
                                                                    <h2 class="color-blue">100</h2>
                                                                    <p class="color-grey">Zona Central</p>
                                                                </v-col>
                                                                <v-col cols="12" md="4" class="mx-auto text-center">
                                                                    <h2 class="color-blue">30</h2>
                                                                    <p class="color-grey">Zona Sur</p>
                                                                </v-col>
                                                            </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            <h4 class="font-size-16">Inicios de Contrato</h4>
                                            <v-row class="">
                                                <v-col class="">
                                                     <v-card height="100px" class="card-numeros2 shadow-1 rounded-lg pa-3">
                                                              <v-row class="caption d-flex align-center pl-4 h-100">
                                                                    <v-col cols="12" class="py-0 mt-2"> <b>10</b> Próximos 30 días.</v-col>
                                                                
                                                                    <v-col cols="12" class="py-0"> <b>4</b> Próximos 60 días.</v-col>
                                                              
                                                                    <v-col cols="12" class="py-0"> <b>9</b> Próximos 90 días.</v-col>
                                                                </v-row>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>

                            </v-card>
                        </v-col>
                        <v-col md="12" lg="4" xl="6">
                            <v-card
                                    class="pa-4 pl-0 elevation-0"
                                    tile
                                    height="100%"
                            >
                                <v-row>
                                    <!-- timeline -->
                                    <v-col  xl="7" lg="12" class="pr-12 pl-0 pt-0">
                                        <template>
                                            <v-timeline dense  class="timeline-status pt-0">
                                                <v-timeline-item
                                                        color="green"
                                                        small
                                                        fill-dot
                                                        class="pb-0"
                                                        
                                                >
                                                    <v-row >
                                                        <v-col>
                                                            <strong class="font-size-20">Estado</strong>
                                                        </v-col>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="green"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-check</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="shadow-1" >
                                                            <v-card-text>
                                                                <strong>
                                                                    Mi perfil de usuario
                                                                </strong>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Mi Empresa</strong>
                                                                        <div class="caption">
                                                                            <a @click="dialog.createCompany = true" href="#">Agregar [+]</a> 
                                                                            |
                                                                            <v-btn text small to="/system/generator/all-companies/" class="text-capitalize" color="green">Ver empresas</v-btn>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">1</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Mis Ofertas</strong>
                                                                        <div class="caption">
                                                                            <a @click="dialog.withdrawalPoint = true" href="#">Agregar [+]</a>
                                                                             |
                                                                            <v-btn text small to="/system/generator/my-offers/" class="text-capitalize" color="green">Ver Ofertas</v-btn>

                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">3</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" @click="$refs.documentLoaded.dialog.show = true" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="12">
                                                                        <strong>Documentos Necesarios</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                No hay documentos cargados
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" to="/system/payment/my-plan/" color="#C6C6C6" dark class="" elevation="2">
                                                            <v-card-text>
                                                                <strong>
                                                                    Aun no tienes solicitudes
                                                                </strong>
                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg focus-blue-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Seguimiento de Solicitudes</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                No hay solicitudes
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="red"
                                                        fill-dot
                                                >
                                                    <template v-slot:icon>
                                                        <v-icon color="#FFF">mdi-close</v-icon>
                                                    </template>
                                                    <v-row class="pt-1">
                                                        <v-card width="100%" class="rounded-lg shadow-1" >
                                                            <v-card-text>
                                                                <v-row>
                                                                    <v-col cols="10">
                                                                        <strong>Contratos Activos</strong>
                                                                        <div class="caption">
                                                                            <span class="red--text">
                                                                                Sin registros
                                                                            </span>
                                                                        </div>
                                                                    </v-col>
                                                                    <v-col cols="2">
                                                                        <h1 class="blue--text font-size-30">0</h1>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-card-text>
                                                        </v-card>
                                                    </v-row>
                                                </v-timeline-item>
                                                <v-timeline-item
                                                        color="green"
                                                        small
                                                        fill-dot
                                                >

                                                </v-timeline-item>

                                            </v-timeline>
                                        </template>
                                    </v-col>
                                    <v-col  xl="5" lg="12" class="pl-8">
                                        <h4 class="font-weight-medium pb-4 font-size-20"> Historial de actividad</h4>
                                        <v-card class="card-novedades pb-12 rounded-lg shadow-1" >
                                            <v-card-text>
                                                <p class="pl-4 font-weight-bold font-size-16 dark-grey--text mb-0">Novedades</p>
                                                <v-list-item v-for="li in 4" two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-subtitle class="font-italic">14 - 07 -2020 / 10:20</v-list-item-subtitle>
                                                        <v-list-item-title>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras tincidunt mauris eu fringilla aliquam. </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-card-text>
                                        </v-card>

                                        <v-card class="card-mi-plan mt-6 pb-12 rounded-lg shadow-1" >
                                            <v-card-text>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Transacciones </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Estadisticas </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-list-item two-line>
                                                    <v-list-item-content>
                                                        <v-list-item-title class="font-weight-bold">Mis Planes </v-list-item-title>
                                                        <v-list-item-subtitle class="red--text">Sin registros</v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>


            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog.createCompany"
                width="724"
        >
            <v-card class="pa-8 elevation-0"
                    tile
            >
                    <v-card-title class="headline pt-0 mx-auto justify-center mb-5">
                        <h2 class="font-weight-regular text-left font-family-1 font-size-30">Agregar una Empresa</h2>
                    </v-card-title>
                <v-card-text>
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Seleccione una Empresa</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['NEOCITY ENERGÍA']"
                                    label="Seleccione una Empresa"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 elevation-0 border-1"
                                    tile
                                    height="160px"
                                    width="160px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="140px"
                                       width="140px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                             <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Rut de la Empresa</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            dense
                                            placeholder="00.000.000-0"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="px-3">
                                <v-col class="pa-0" cols="4">
                                    <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Razon Social</v-subheader>
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                    <v-text-field
                                            placeholder="Razon Social Empresa"
                                            dense

                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Región de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                          <v-select
                                    :items="['Metropolitana']"
                                    placeholder="Selecciona la región de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                     <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Comuna de Retiro (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                             <v-select
                                    :items="['Las Condes']"
                                    placeholder="Selecciona la comuna de retiro"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Giro Comercial (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Giro Empresa"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Direccion Comercial (*)
                            </v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Calle #000, Comuna, Region, Pais"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Representante Legal (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Nombre Apellido"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 27px; ">Correo Electronico (*)</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="info@neocity.cl"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Teléfono</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="+56 2 2222 2222"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-5 px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Sitio Web</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="www.neocity.cl"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-start">
                    <v-btn color="primary"
                       raised
                       dark
                       @click="dialog.createCompany = false"
                       class="pa-6">Agregar Empresa</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>

        <v-dialog
                v-model="dialog.withdrawalPoint"
                width="724"
        >
            <v-card class="pa-8 elevation-0"
                    tile
                
            >
                <v-card-title class="headline pt-0 mx-auto justify-center">
                    <h2 class="font-weight-medium text-center font-family-1 font-size-30">Agregar Oferta</h2>
                </v-card-title>
                    <v-card-text>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Empresa</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['NEOCITY ENERGÍA']"
                                    label="Seleccione una Empresa"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 elevation-1"
                                    tile
                                    height="150px"
                                    width="150px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="120px"
                                       width="120px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                            <v-text-field

                                    label="Nombre de la Oferta"
                                    value="X. Los Lagos - 1 / 6m"
                                    dense
                            ></v-text-field>
                            <div class="mx-auto">
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#004E85"
                                        label
                                        text-color="white"
                                >
                                    Bloque A <br>
                                    0 a 8 am.
                                </v-chip>
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#FF9A1B"
                                        label
                                        text-color="white"
                                >
                                    Bloque B <br>
                                    8 a 20 pm.
                                </v-chip>
                                <v-chip
                                        class="ma-2 py-5"
                                        color="#0172C0"
                                        label
                                        text-color="white"
                                >
                                    Bloque C <br>
                                    20 a 24 pm.
                                </v-chip>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Región/es</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['V Región']"
                                    label="Seleccione una Región"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Duración del Contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['6 Meses']"
                                    label="Seleccione una Duración"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Cantidad de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['150 GWh']"
                                    label="Seleccione una Cantidad"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Tamaño de la oferta</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['opcion 1','opcion 2']"
                                    label="Seleccione el Tamaño de la oferta"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Precio de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="30 USD/MWh en 220kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption pl-7 px-3 border-bottom-1" style="height: 31px; ">Recargo de Energía</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="3">
                            <v-text-field
                                    style="color:green !important;"
                                    placeholder="Precio de Energía"
                                    value="+2% 110 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="3">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="+3% 66 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                        <v-col class="pa-0" cols="2">
                            <v-text-field
                                    style="color: green !important;"
                                    placeholder="Precio de Energía"
                                    value="+5% 23 Kv"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Precio de Potencia</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 8USD/KW mes','opcion 2']"
                                    label="Seleccione el Precio de Potencia"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Peajes</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 7USD/MKW','opcion 2']"
                                    label="Seleccione el Precio de Peajes"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Servicios Complementarios</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Traspaso de costos, máx. 1USD/MKW ','opcion 2']"
                                    label="Seleccione Servicios Complementarios"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 31px; ">Indexacion</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-select
                                    :items="['Sin indexación / CPI Semestral','opcion 2']"
                                    label="Seleccione Indexacion"
                                    dense
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="primary"
                           raised
                           dark
                           @click="dialog.withdrawalPoint = false"
                           class="pa-6">Agregar Oferta</v-btn>
                </v-card-actions>

            </v-card>

        </v-dialog>

        
        <document-loaded-component
            ref="documentLoaded"
        ></document-loaded-component>
    </v-col>
</template>
<script>
  import DocumentLoadedComponent from '@/components/system/DocumentLoadedComponent.vue';

    export default {
        name: 'Dashboard',
        data() {
            return {
                dialog:{
                    createCompany:false,
                    withdrawalPoint:false,
                    payment:false
                }
            }
        },
        components: {
            DocumentLoadedComponent
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>